<template>
  <div class="app-container">
    <div class="games-container">
      <div class="game-list-container">
        <div class="games-title">在線儲值</div>
        <div class="game-form">
            <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                <el-form-item label="會員賬號" prop="uid">
                    <el-input type="text" v-model="ruleForm.uid" autocomplete="off" @change="getChrIdx"></el-input>
                </el-form-item>
                <el-form-item label="遊戲名稱" prop="region">
                    <el-select v-model="ruleForm.region" placeholder="請選擇遊戲名稱">
                      <el-option
                        v-for="item in GameList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                    <span style="font-size:11px;color:gray">&nbsp;&nbsp;請選擇要儲值的遊戲名稱</span>
                </el-form-item>
                <el-form-item label="角色名稱" prop="chrId">
                    <el-select v-model="ruleForm.chrId" @change="SelectChr" @visible-change="checkuid" placeholder="請選擇遊戲角色">
                      <el-option
                      v-for="item in ChrList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                      </el-option>
                    </el-select>
                    <span style="font-size:11px;color:gray">&nbsp;&nbsp;請選擇要儲值的遊戲角色</span>
                </el-form-item>
                <el-form-item label="儲值方式" prop="methods">
                    <el-select v-model="ruleForm.methods" placeholder="請選擇儲值方式" @change="SelectMethods">
                      <el-option
                      v-for="item in payment"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                      </el-option>
                    </el-select>
                    <a href="" style="font-size:11px;">&nbsp;&nbsp;*新馬澳洲儲值WISE匯款教學?</a>
                </el-form-item>
                <el-form-item prop="agree">
                    <el-checkbox checked>同意接受 <a href="/policy">《會員服務條款》</a> .<a href="/policy">《個人隱私條款》</a></el-checkbox>
                </el-form-item>
                <el-form-item style="text-align:center">
                    <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
                </el-form-item>
            </el-form>
        </div>
      </div>
    </div>
  </div>
</template>
 
<script>
import consoleBasic from 'caniuse-lite/data/features/console-basic';

  export default {
    data() {
      var validateuid = (rule, value, callback) => {
         const reg = /^[a-zA-Z0-9]{4,16}$/
        if (!reg.test(value)) {
            callback(new Error('登入賬號必須由字母或數字組合,請輸入4-16位字符'))
        } 
        else {
          callback();
        }
      };
      var validateregion= (rule, value, callback) => {
        
        if (value==="") {
            callback(new Error('請選擇要儲值的遊戲'))
        } 
        else {
          callback();
        }
      };
      var validateChrId = (rule, value, callback) => {
        if (value==="") {
            callback(new Error('請選擇要儲值的角色名稱'))
        } 
        else {
          callback();
        }
      };
      var validatemethods = (rule, value, callback) => {
        if (value==="") {
            callback(new Error('請選儲值方式，否則無法完成付款'))
        } 
        else {
          callback();
        }
      };
      return {
        ruleForm: {
          uid:'',
          region:'滅魂墨香',
          chrId: '',
          methods: '',   
        },
        rules: {           
          uid: [{ validator: validateuid, trigger: 'blur' }],
          region:[ { validator: validateregion, trigger: 'blur' }],
          chrId: [{ validator: validateChrId, trigger: 'blur' }],
          methods: [{ validator: validatemethods, trigger: 'blur' }],
        },
        payment: [{
          value: 'alipay',
          label: '支付寶'
        }, {
          value: 'wechat',
          label: '微信支付'
        }, {
          value: 'fps',
          label: '香港轉數快'
        }, {
          value: 'WISE',
          label: 'WISE匯款'
        }, {
          value: 'Card',
          label: '信用卡支付'
        }],
        GameList:[{label:'滅魂墨香',value:'滅魂墨香'}],
        methods: "",
        CharacterIdx:0,
        ChrList:[],
        region:"滅魂墨香"
      };
    },
    methods: {
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
                
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },

      getChrIdx() {
        this.$refs.ruleForm.validateField('uid',(error) => {
          if (!error) {
                this.$axios
                    .get("/getChrList.asp", {
                    params: {
                        uid: this.ruleForm.uid
                    }
                    })
                    .then((res)=>{
                      if(res.data.code != '200'){
                        this.$message({
                            message: res.data.data,
                            type: "error"
                        });
                      }else{
                        this.ChrList=res.data.data
                      }

                    })
                    .catch((error)=>{
                    this.$message({
                        message: "請求超時，請稍後再嘗試",
                        type: "error"
                    });
                });
           }
        });
      },
      checkuid(e){
        this.$refs.ruleForm.validateField('uid',(error) => {})
        this.$refs.ruleForm.validateField('region',(error) => {})
      },
      SelectChr(val){
        this.CharacterIdx = val;
      },
      SelectMethods(val){
        this.methods = val;
      },
    }
  }
</script>


 
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a:link {color:#409EFF; text-decoration:none;} 
a:active{color:#409EFF; text-decoration:none;}
a:visited {color:#409EFF; text-decoration:none;}
a:hover {color:#409EFF; text-decoration:none;}
.app-container {
  display: block;
}
.games-container {
  max-width: 1281px;
  margin: auto;
}
.game-list-container {
  padding-bottom: 50px;
}
.games-title {
  margin-top: 20px;
  margin-left: 12px;
  font-size: 24px;
  font-family: Noto Sans KR, sans-serif;
  font-weight: 400;
  color: #000;
  opacity: 0.87;
  padding-bottom: 20px;
}
.game-form {
    max-width: 500px;
    margin:0 auto;
}
.el-button--primary {
    min-width:228px;
    min-height: 38px;
}

</style>


// WEBPACK FOOTER //
// src/components/Payment/Index.vue